import React from 'react';
import { useAuth } from './AuthContext';

export const Login = () => {
    const { onLogin, onEmailChange, onPasswordChange } = useAuth();

    return (
        <div className="Auth-form-container">
            <div className="Auth-form">
                <div className="Auth-form-content">
                    <h3 className="Auth-form-title">Sign In</h3>
                    <div className="form-group mt-3">
                        <label>Email address</label>
                        <input
                            type="email"
                            name="username" required autoComplete="username"
                            className="form-control mt-1"
                            placeholder="Enter email"
                            autoFocus={true}
                            onChange={onEmailChange}
                        />
                    </div>
                    <div className="form-group mt-3">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password" required autoComplete="current-password"
                            className="form-control mt-1"
                            placeholder="Enter password"
                            onChange={onPasswordChange}
                        />
                    </div>
                    <div className="d-grid gap-2 mt-3">
                        <button className="btn btn-primary" onClick={onLogin}>
                            Submit
                        </button>
                    </div>
                    <p className="forgot-password text-right mt-2">
                        <a href="/">Back to Home Page</a>
                    </p>
                </div>
            </div>
        </div>
    )
}